import { render, staticRenderFns } from "./bh.vue?vue&type=template&id=8a7a82e4&scoped=true&"
import script from "./bh.vue?vue&type=script&lang=js&"
export * from "./bh.vue?vue&type=script&lang=js&"
import style0 from "./bh.vue?vue&type=style&index=0&id=8a7a82e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7a82e4",
  null
  
)

export default component.exports